var _path, _rect, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PDF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.412,
    height: 19.999,
    viewBox: "0 0 17.412 19.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4568",
    "data-name": "Path 4568",
    d: "M27.354,9H22.712V4.357A.357.357,0,0,0,22.355,4h-10A.357.357,0,0,0,12,4.357V23.639a.357.357,0,0,0,.357.357h15a.357.357,0,0,0,.357-.357V9.356A.357.357,0,0,0,27.354,9Z",
    transform: "translate(-10.301 -3.998)",
    fill: "#eee"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6121",
    "data-name": "Rectangle 6121",
    width: 12.767,
    height: 6.874,
    rx: 1,
    transform: "translate(0 9.996)",
    fill: "#ff3717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4569",
    "data-name": "Path 4569",
    d: "M45.61,9.1l-5-5A.357.357,0,0,0,40,4.353v5a.357.357,0,0,0,.357.357h5A.357.357,0,0,0,45.61,9.1Z",
    transform: "translate(-28.303 -3.994)",
    fill: "#e0e0e0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4574",
    "data-name": "Path 4574",
    d: "M1.2-4.411V-3.33H.571V-6.4h1.2a1.448,1.448,0,0,1,.486.076,1.049,1.049,0,0,1,.363.212.905.905,0,0,1,.227.322,1.041,1.041,0,0,1,.078.406,1,1,0,0,1-.078.4.832.832,0,0,1-.227.306,1.042,1.042,0,0,1-.363.195,1.591,1.591,0,0,1-.486.068Zm0-.512h.565A.718.718,0,0,0,2-4.957a.426.426,0,0,0,.16-.094.366.366,0,0,0,.092-.144.551.551,0,0,0,.03-.183.619.619,0,0,0-.03-.191.452.452,0,0,0-.092-.162A.442.442,0,0,0,2-5.844a.587.587,0,0,0-.233-.042H1.2ZM3.571-3.33V-6.4h.944a1.476,1.476,0,0,1,.568.106,1.278,1.278,0,0,1,.443.3,1.368,1.368,0,0,1,.288.463,1.662,1.662,0,0,1,.1.6v.139a1.669,1.669,0,0,1-.1.6,1.34,1.34,0,0,1-.289.462,1.285,1.285,0,0,1-.446.3,1.5,1.5,0,0,1-.571.105ZM4.2-5.886v2.049h.306a.685.685,0,0,0,.571-.248,1.116,1.116,0,0,0,.2-.707v-.143a1.113,1.113,0,0,0-.194-.709.684.684,0,0,0-.567-.241Zm4.235,1.3H7.225V-3.33H6.592V-6.4h2v.512H7.225v.792H8.439Z",
    transform: "translate(1.803 18.298)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.4c1ee07a786cdd2c663508dbcef55e0b.svg";
export { ForwardRef as ReactComponent };